module.exports = __webpack_public_path__ + "static/media/square-unlock-icon.e7251916.svg";